import apiClient from './apiClient';



export const deployImage = async (params: { cluster: string, namespace: string, image: string, deploymentName: string }) => {
    const res = await apiClient.post('/deployment/deploy', params);
    return res.data;
};
export const fetchAcrRepositories = async () => {
    const res = await apiClient.get('/deployment/acr-repositories');
    return res.data.repositories;
};

export const fetchAcrTags = async (repository: string) => {
    const res = await apiClient.get(`/deployment/acr-tags?repository=${repository}`);
    return res.data.tags;
};

export const fetchAllAcrTags = async () => {
    const res = await apiClient.get('/deployment/acr-all-tags');
    return res.data.tags;
};

export const bulkDeploy = async (params: { cluster: string, namespace: string, images: { repository: string, tag: string }[] }) => {
    const res = await apiClient.post('/deployment/bulk-deploy', params);
    return res.data;
};